<template>
  <v-container :class="'mt-0 pt-0 pb-0'" fluid>
    <v-card class="pa-0 ma-0 mt-5 mb-5" elevation="0">
      <v-row>
        <v-col class="my-0 py-0" col="3">
          <combobox-filter2000
            class="mb-0 pb-0"
            v-model="bankFilterArray"
            :label="this.$t('cards.banks')"
            :items="banks"
            itemText="bankName"
            itemValue="bankId"
            :prepend-icon="'mdi-bank'"
            style="z-index: 200"
          />
        </v-col>
        <v-col class="my-0 py-0" col="3">
          <combobox-filter2000
            class="mb-0 pb-0"
            v-model="branchFilterArray"
            :label="this.$t('cards.branches')"
            :items="branchesOfBanks"
            itemText="name"
            itemValue="branchId"
            :prepend-icon="'mdi-source-branch'"
            style="z-index: 200"
          />
        </v-col>
        <v-col class="my-0 py-0" col="3">
          <combobox-filter2000
            class="mb-0 pb-0"
            v-model="devicesFilterArray"
            :label="this.$t('cards.devices')"
            :items="devices"
            itemText="deviceName"
            itemValue="deviceId"
            :prepend-icon="'mdi-cash-register'"
            style="z-index: 200"
          />
        </v-col>
        <v-col cols="3" class="my-0 py-0">
          <v-row>
            <v-spacer />
            <SearchButtons v-on:clear="clearFilters" v-on:get="getKiosks" />
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="my-0 py-0" col="3">
          <v-text-field
            :label="this.$t('kiosks.name')"
            v-model="kioskNameFilter"
            :append-icon="'mdi-close'"
            @click:append="() => (kioskNameFilter = '')"
            :prepend-icon="'mdi-printer'"
          />
        </v-col>
        <v-col class="my-0 py-0" col="3">
          <combobox-filter2000
            class="mb-0 pb-0"
            v-model="kioskStatusFilterArray"
            :label="this.$t('kiosks.kioskStatus')"
            :items="kioskStatuses"
            itemText="statusName"
            itemValue="deviceStatusId"
            :prepend-icon="'mdi-clock-outline'"
            translate
            :localizationFunc="
              (val) => $t('devicestatusNames.statusName' + val.deviceStatusId)
            "
            style="z-index: 200"
          />
        </v-col>
        <v-col class="my-0 py-0" col="3">
          <combobox-filter2000
            class="mb-0 pb-0"
            v-model="softwareStatusFilterArray"
            :label="this.$t('kiosks.softwareStatus')"
            :items="softwareStatuses"
            itemText="statusName"
            itemValue="deviceStatusId"
            :prepend-icon="'mdi-clock-outline'"
            translate
            :localizationFunc="
              (val) => $t('devicestatusNames.statusName' + val.deviceStatusId)
            "
            style="z-index: 200"
          />
        </v-col>
        <v-col class="my-0 py-0" col="23">
          <v-text-field
            :label="this.$t('kiosks.address')"
            v-model="addressFilter"
            :append-icon="'mdi-close'"
            @click:append="() => (addressFilter = '')"
            :prepend-icon="'mdi-map-marker-outline'"
          />
        </v-col>
      </v-row>
    </v-card>
    <v-card>
      <v-card-title class="mt-3 mb-0 pb-0 mt-0 pt-0">
        <v-select
          v-model="intervalTime"
          class="mt-4 mr-4 ml-10"
          style="max-width: 120px"
          :items="intervalTimeValues"
          :label="this.$t('cards.refresh')"
        />
        <v-select
          v-on:change="getKiosks"
          class="mt-4 mr-4 ml-1"
          v-model="limit"
          :items="limitValues"
          style="max-width: 120px"
          :label="this.$t('cards.rowsPerPage')"
          item-text="value"
          item-value="value"
        />
        <KisosksAddEditDialog
          v-if="this.$store.getters.CAN_ADD_DEVICES"
          :mode="0"
          :branch="branchParam"
          :bank="bankParamModeNull"
          v-on:created="onCreated"
          v-on:error="onError"
        />
        <KisosksAddEditDialog
          v-if="this.$store.getters.CAN_EDIT_DEVICES && isActive"
          :mode="1"
          :bank="bankParamModeOne"
          :device="selected[0]"
          v-on:saved="onSaved"
        />

        <KisosksChangeDevice v-if="isActive" :selectedKiosk="selected[0]" />
        <Confirm1
          v-if="this.$store.getters.CAN_DELETE_DEVICES && isActive"
          :title="deleteKioskTitle"
          :text="confirmText"
          :tooltipText="$t('kiosks.delete')"
          v-on:ok="() => onDeleteKiosk(selected[0])"
        />
        <Confirm1
          v-if="this.$store.getters.CAN_DELETE_DEVICES && isNotActive"
          :disabled="this.$store.getters.CAN_DELETE_DEVICES"
          :title="restoreConfirmTitle"
          :tooltipText="$t('kiosks.restore')"
          v-on:ok="onRestore"
          iconName="mdi-restore"
        />
        <EditKeyTPK
          v-if="hasManageKeyRights && selected.length > 0"
          :disabled="selected.length !== 1"
          :kioskInfo="selected[0]"
        />
        <Confirm
          class="ml-1"
          v-if="hasManageKeyRights && selected.length > 0"
          :button1Icon="false"
          :disabled="selected.length !== 1"
          :buttonIcon="'mdi-key-remove'"
          :dialogTitle="$t('ConfirmAction')"
          :dialogText="$t('kiosks.resetKeyTPK')"
          :okText="$t('Continue')"
          :cancelText="$t('Cancel')"
          :tooltipText="$t('kiosks.resetKeyTPK')"
          v-on:ok="onResetKeyTPK()"
        />
        <v-spacer />
        <CardsPerHopperForm
          v-if="isActive"
          :device="selected[0]"
          :hoppersCount="hoppersCount"
          :key="cardsPerHopperFormKey"
          @close="cardsPerHopperFormKey++"
          v-on:error="onError"
        />
        <MediaDownloadForm
          v-if="hasManageKeyRights && selected.length > 0"
          buttonIcon="mdi-camera"
          :dialogTitle="$t('kiosks.downloadMedia')"
          :okText="$t('Continue')"
          :cancelText="$t('Cancel')"
          :onOkAction="downloadMedia"
          :kioskId="selected.length === 1 ? this.selected[0].kioskId : ''"
          :tooltipText="$t('kiosks.downloadMedia')"
        />
        <DownloadForm
          v-if="hasManageKeyRights && selected.length > 0"
          buttonIcon="mdi-text-box-search-outline"
          :dialogTitle="$t('kiosks.downloadLogs')"
          :okText="$t('Continue')"
          :cancelText="$t('Cancel')"
          :onOkAction="downloadLogs"
          :tooltipText="$t('kiosks.downloadLogs')"
        />
        <Confirm1
          v-if="hasManageKeyRights && isActive"
          :title="$t('kiosks.toServiceModeTitle')"
          :tooltipText="$t('kiosks.toServiceModeTooltip')"
          v-on:ok="kioskToServiceMode"
          iconName="mdi-cogs"
        />
        <Confirm1
          v-if="hasManageKeyRights && isActive"
          :title="$t('kiosks.restartApplicationTitle')"
          :tooltipText="$t('kiosks.restartApplicationTooltip')"
          v-on:ok="restartApplication"
          iconName="mdi-application"
        />
        <Confirm1
          v-if="hasManageKeyRights && isActive"
          :title="$t('kiosks.restartPcTitle')"
          :tooltipText="$t('kiosks.restartPcTooltip')"
          v-on:ok="restartPc"
          iconName="mdi-restart"
        />
      </v-card-title>
      <v-data-table
        class="mb-10"
        fixed-header
        v-model="selected"
        :headers="headers"
        :items="filteredKiosks"
        :single-select="singleSelect"
        :sort-by.sync="currentSort"
        :sort-desc.sync="currentSortDesc"
        :custom-sort="customSort"
        :disable-pagination="true"
        item-key="kioskId"
        :search="search"
        hide-default-footer
        :loading="loading"
        show-select
        loading-text="Loading... Please wait"
        :height="tableHeight"
      >
        <template v-slot:item.kioskStatusName="{ item }">
          <span
            v-if="item.kioskStatusName === 'Stopped'"
            style="color: red; font-weight: bold"
            >{{ item.kioskStatusName }}</span
          >
          <span
            v-else-if="item.kioskStatusName === 'Running'"
            style="color: green; font-weight: bold"
            >{{ item.kioskStatusName }}</span
          >
          <span
            v-else-if="item.kioskStatusName === 'Ready'"
            style="color: green; font-weight: bold"
            >{{ item.kioskStatusName }}</span
          >
          <span
            v-else-if="item.kioskStatusName === 'Busy'"
            style="color: orange; font-weight: bold"
            >{{ item.kioskStatusName }}</span
          >
          <span
            v-else-if="item.kioskStatusName === 'Error'"
            style="color: red; font-weight: bold"
            >{{ item.kioskStatusName }}</span
          >
          <span
            v-else-if="item.kioskStatusName === 'Unavailable'"
            style="color: red; font-weight: bold"
            >{{ item.kioskStatusName }}</span
          >
          <span v-else style="color: gray; font-weight: bold">{{
            item.kioskStatusName
          }}</span>
        </template>
        <template v-slot:item.softwareStatusName="{ item }">
          <span
            v-if="item.softwareStatusName === 'Stopped'"
            style="color: red; font-weight: bold"
            >{{ item.softwareStatusName }}</span
          >
          <span
            v-else-if="item.softwareStatusName === 'Running'"
            style="color: green; font-weight: bold"
            >{{ item.softwareStatusName }}</span
          >
          <span
            v-else-if="item.softwareStatusName === 'Ready'"
            style="color: green; font-weight: bold"
            >{{ item.softwareStatusName }}</span
          >
          <span
            v-else-if="item.softwareStatusName === 'Busy'"
            style="color: orange; font-weight: bold"
            >{{ item.softwareStatusName }}</span
          >

          <span
          v-else-if="item.softwareStatusName === 'Error'"
          style="color: red; font-weight: bold"
          :title="`${$t('Error')}: ${item.message}`"
          >{{ item.softwareStatusName }}</span>

          <span
            v-else-if="item.softwareStatusName === 'Unavailable'"
            style="color: red; font-weight: bold"
            >{{ item.softwareStatusName }}</span
          >
          <span v-else style="color: gray; font-weight: bold">{{
            item.softwareStatusName
          }}</span>

        </template>

        <template v-slot:item.deviceStatus="{ item }">
          <span
            v-if="item.deviceStatus === 'Error'"
            style="color: red; font-weight: bold"
            >{{ item.deviceStatus }}</span
          >
          <span
            v-else-if="item.deviceStatus === 'Ready'"
            style="color: green; font-weight: bold"
            >{{ item.deviceStatus }}</span
          >
          <span
            v-else-if="item.deviceStatus === 'Busy'"
            style="color: orange; font-weight: bold"
            >{{ item.deviceStatus }}</span
          >
          <span
            v-else-if="item.deviceStatus === 'Unavailable'"
            style="color: red; font-weight: bold"
            >{{ item.deviceStatus }}</span
          >
          <span v-else style="color: gray; font-weight: bold">{{
            item.deviceStatus
          }}</span>
        </template>

        <template v-slot:item.embosserRemainingPercent="{ item }">
          <v-progress-circular
            :value="item.embosserRemainingPercent"
            v-if="
              item.embosserRemainingPercent <= 10 &&
              item.embosserRemainingPercent >= 0
            "
            style="color: red; font-weight: bold"
            >{{ item.embosserRemainingPercent }}</v-progress-circular
          >
          <v-progress-circular
            :value="item.embosserRemainingPercent"
            v-else-if="
              item.embosserRemainingPercent > 10 &&
              item.embosserRemainingPercent <= 30
            "
            style="color: orange; font-weight: bold"
            >{{ item.embosserRemainingPercent }}</v-progress-circular
          >
          <v-progress-circular
            :value="item.embosserRemainingPercent"
            v-else-if="item.embosserRemainingPercent > 30"
            style="color: green; font-weight: bold"
            >{{ item.embosserRemainingPercent }}</v-progress-circular
          >
          <v-progress-circular
            :value="item.embosserRemainingPercent"
            v-else-if="item.embosserRemainingPercent == -1"
            style="color: lightgray; font-weight: bold"
            >{{ 'n/a' }}</v-progress-circular
          >
          <v-progress-circular
            :value="item.embosserRemainingPercent"
            v-else
            style="color: gray; font-weight: bold"
            >{{ item.embosserRemainingPercent }}</v-progress-circular
          >
        </template>

        <template v-slot:item.printerRemainingPercent="{ item }">
          <v-progress-circular
            :value="item.printerRemainingPercent"
            v-if="
              item.printerRemainingPercent <= 10 &&
              item.printerRemainingPercent >= 0
            "
            style="color: red; font-weight: bold"
            >{{ item.printerRemainingPercent }}</v-progress-circular
          >
          <v-progress-circular
            :value="item.printerRemainingPercent"
            v-else-if="
              item.printerRemainingPercent > 10 &&
              item.printerRemainingPercent <= 30
            "
            style="color: orange; font-weight: bold"
            >{{ item.printerRemainingPercent }}</v-progress-circular
          >
          <v-progress-circular
            :value="item.printerRemainingPercent"
            v-else-if="item.printerRemainingPercent > 30"
            style="color: green; font-weight: bold"
            >{{ item.printerRemainingPercent }}</v-progress-circular
          >
          <v-progress-circular
            :value="item.printerRemainingPercent"
            v-else-if="item.printerRemainingPercent == -1"
            style="color: lightgray; font-weight: bold"
            >{{ 'n/a' }}</v-progress-circular
          >
          <v-progress-circular
            :value="item.printerRemainingPercent"
            v-else
            style="color: gray; font-weight: bold"
            >{{ item.printerRemainingPercent }}</v-progress-circular
          >
        </template>

        <template v-slot:item.indentRemainingPercent="{ item }">
          <v-progress-circular
            :value="item.indentRemainingPercent"
            v-if="
              item.indentRemainingPercent <= 10 &&
              item.indentRemainingPercent >= 0
            "
            style="color: red; font-weight: bold"
            >{{ item.indentRemainingPercent }}</v-progress-circular
          >
          <v-progress-circular
            :value="item.indentRemainingPercent"
            v-else-if="
              item.indentRemainingPercent > 10 &&
              item.indentRemainingPercent <= 30
            "
            style="color: orange; font-weight: bold"
            >{{ item.indentRemainingPercent }}</v-progress-circular
          >
          <v-progress-circular
            :value="item.indentRemainingPercent"
            v-else-if="item.indentRemainingPercent > 30"
            style="color: green; font-weight: bold"
            >{{ item.indentRemainingPercent }}</v-progress-circular
          >
          <v-progress-circular
            :value="item.indentRemainingPercent"
            v-else-if="item.indentRemainingPercent == -1"
            style="color: lightgray; font-weight: bold"
            >{{ 'n/a' }}</v-progress-circular
          >
          <v-progress-circular
            :value="item.indentRemainingPercent"
            v-else
            style="color: gray; font-weight: bold"
            >{{ item.indentRemainingPercent }}</v-progress-circular
          >
        </template>

        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-row align="start">
      <v-col class="d-flex">
        <v-row style="display: flex; justify-content: center">
          <v-pagination
            v-on:input="getKiosks"
            v-model="page"
            :length="paginationLength"
            :total-visible="totalVisible"
          />
        </v-row>
      </v-col>
      <p class="d-flex v-card__title">
        {{ $t('cards.records') }} {{ $t('from') }} {{ limit * (page - 1) + 1 }}
        {{ $t('to') }} {{ limit * page }}
      </p>
      <p align="right" class="d-flex v-card__title">
        {{ $t('cards.total') }}: {{ totalCount }}
      </p>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import storageManager from '@/services/storageManager';
import CardsPerHopperForm from '@/components/Kiosks/CardsPerHopperForm';
import Confirm from '@/components/Dialogs/Confirm';
import Confirm1 from '@/components/Confirm';
import store from '../store';
import ComboboxFilter2000 from '@/components/FiltersComponent/ComboboxFilter2000';
import EditKeyTPK from '../components/Dialogs/EditKeyTPK';
import { NamesDB } from '@/constants/DBNames.js';
import SearchButtons from '../components/FiltersComponent/SearchButtons';
import KisosksAddEditDialog from '@/components/Kiosks/KiosksAddEditDialog.vue';
import KisosksChangeDevice from '@/components/Kiosks/KiosksChangeDeviceDialog.vue';
import DownloadForm from '@/components/Kiosks/DownloadForm.vue';
import MediaDownloadForm from '@/components/Kiosks/MediaDownloadForm.vue';
import Vue from 'vue';
import { notifyError, notifySuccess } from '@/services/notifications';
export default {
  name: 'Kiosks',
  data() {
    return {
      selectedDevice: null,
      hoppersCount: 0,

      cardsPerHopperFormKey: 0,

      waitingKiosksResponse: false,
      manageKioskDialogKey: 0,
      offsetHeight: this.$store.getters.HEIGHT_OFFSET,

      intervalTime: 30,

      interval: {},
      header: { Authorization: store.state.authToken },
      dialog: false,
      page: 1,
      limit: 10,

      paginationLength: 100,
      totalCount: '',
      totalVisible: 10,
      search: '',
      searchExample: '',
      selected: [],
      singleSelect: false,

      cards: [],
      cardStatuses: [],
      cardPriorities: [],
      banks: [],
      branches: [],
      devices: [],
      kiosks: [],
      deviceStatuses: [],
      kioskStatuses: [],
      address: '',
      devicesDesigns: [],
      jobs: [],
      loading: false,
      cardStatusesFilter: 0,
      cardStatusesFilterArray: [],
      cardPrioritiesFilter: 0,
      cardPrioritiesFilterArray: [],
      bankText: '',
      productFilterArray: [],
      jobFilterArray: [],
      panFilter: '',
      cardholderFilter: '',
      jobDateFilter: [],

      // filters
      kioskStatuse: [],
      softwareStatuses: [],

      bankFilter: 0,
      bankFilterArray: [],
      branchFilter: 0,
      branchFilterArray: [],
      isMounted: false,
      kioskNameFilter: '',
      devicekNameFilter: '',
      addressFilter: '',
      devicesFilterArray: [],
      kioskStatusFilterArray: [],
      softwareStatusFilterArray: [],

      changedDevicesId: [],

      activator: null,
      attach: null,
      editing: null,
      index: -1,
      nonce: 1,
      menu: false,
      model: [
        {
          text: 'Foo',
          color: 'blue',
        },
      ],
      x: 0,
      searchCombobox: null,
      y: 0,
      lastSort: 'bankName',
      currentSortDesc: [],
      currentSort: [],
    };
  },
  filters: {
    msToS(ms) {
      return ms;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      if (date === undefined) return dateString;
      else {
        return date.toLocaleString();
      }
    },
  },
  watch: {
    async currentSortDesc() {
      this.getKiosks();
    },
    async currentSort(val) {
      if (val.length != 0) {
        this.lastSort = val[0];

        this.getKiosks();
      }
    },

    async selected(value) {
      if (value.length === 0) {
        return;
      }

      const apiUrl = window.configs?.API_URL;

      const deviceId = value[0].deviceId; // Получаем deviceId первой выбранной строки

      try {
        const response = await axios.get(apiUrl + `/devices/${deviceId}`, {
          headers: { Authorization: storageManager.getItem('token') },
        });

        this.selectedDevice = response.data;
        this.hoppersCount = response.data.hoppersCount;
      } catch (error) {
        console.error('Ошибка при запросе:', error);
      }
    },

    bankFilterArray: async function () {
      if (this.isMounted && this.$localStorageObj.getKeepFiltersValue(this.$store.getters.USERNAME)) {
        this.$localStorageObj.setBankFilter(this.bankFilterArray, this.pageKey, this.$store.getters.USERNAME);
      }
      this.branches = [];

      const banksId = this.bankFilterArray.map((b) => b.bankId);

      this.$axios.branches
        .getByBanksArrayForCards(banksId)
        .then((response) => response.data)
        .then((json) => {
          this.branches = json;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    branchFilterArray: async function () {
      if (this.isMounted && this.$localStorageObj.getKeepFiltersValue(this.$store.getters.USERNAME)) {
        this.$localStorageObj.setBranchFilter(this.branchFilterArray, this.pageKey, this.$store.getters.USERNAME);
      }
      this.devices = [];

      if (
        this.branchFilterArray === null ||
        this.branchFilterArray.length === 0
      )
        return;

      const branchId = this.branchFilterArray.map((val) => val.branchId);

      this.$axios.devices
        .getByBranchesArrayForCards(branchId)
        .then((response) => response.data)
        .then((json) => {
          this.devices = json;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    page: async function () {
      this.kiosks = [];
      this.getKiosksAndStartTimer();
    },
    intervalTime: function () {
      this.$localStorageObj.setIntervalTime(this.intervalTime);
      this.getKiosksAndStartTimer();
    },
    limit: function () {
      this.page = 1;
    },
    filterJson() {
      this.getKiosksAndStartTimer();
    },
  },
  computed: {
    pageKey() {
      return this.$route.path;
    },
    restoreConfirmTitle() {
      return (
        this.$t('confirm.restoreKiosk') + ' ' + this.selected[0].kioskName + '?'
      );
    },
    confirmText() {
      return this.$t('confirm.text');
    },
    deleteKioskTitle() {
      return (
        this.$t('confirm.deleteKiosk') + ' ' + this.selected[0].kioskName + '?'
      );
    },
    isActive() {
      return this.selected.length === 1 && this.selected[0].kioskStatusId !== 0;
    },
    isNotActive() {
      return this.selected.length === 1 && this.selected[0].kioskStatusId === 0;
    },
    branchParam() {
      return this.branchFilterArray == null ||
        this.branchFilterArray.length == 0
        ? null
        : this.branchFilterArray[0];
    },
    bankParamModeNull() {
      return this.bankFilterArray == null || this.bankFilterArray.length == 0
        ? null
        : this.bankFilterArray[0];
    },
    bankParamModeOne() {
      try {
        const branchId = this.selectedDevice[0].branchId;
        const bankId = this.branches[branchId].bankId;

        return Object.assign({}, this.banks[bankId]);
      } catch {
        return null;
      }
    },
    intervalTimeValues() {
      return this.$store.getters.UPDATE_FREQUENCY;
    },
    limitValues() {
      var res = this.$store.getters.COUNT_ROWS;

      if (res === undefined || res === null || res.length === 0)
        return [
          { value: 10 },
          { value: 25 },
          { value: 50 },
          { value: 500 },
          { value: 2000 },
          { value: 5000 },
        ];

      return res;
    },
    tableHeight() {
      const max = window.innerHeight;
      const headerH = 68;
      const filterH = 150;
      const tHeaderH = 68;
      const tFooterH = 86;
      const infelicity = 0;

      const height =
        max -
        (headerH +
          filterH +
          tHeaderH +
          tFooterH +
          infelicity +
          this.offsetHeight);

      return height.toString() + 'px';
    },
    headers() {
      const result = [
        {
          align: 'start',
          sortable: false,
          value: 'name',
        },
        {
          text: this.$t('referenceBooks.banks.Name'),
          value: 'bankName',
          width: '150px',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.branches.Branch'),
          value: 'branchName',
          sortable: true,
        },
        {
          text: this.$t('kiosks.name'),
          value: 'kioskName',
          width: '150px',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.devices.Device'),
          value: 'deviceName',
          width: '150px',
          sortable: true,
        },
        { text: this.$t('kiosks.address'), value: 'address', sortable: true },
      ];

      result.splice(
        result.length,
        0,
        { text: this.$t('kiosks.link'), value: 'link', sortable: true },
        {
          text: this.$t('kiosks.kioskStatus'),
          value: 'kioskStatusName',
          sortable: true,
        }
      );

      result.splice(result.length, 0, {
        text: this.$t('kiosks.softwareStatus'),
        value: 'softwareStatusName',
        sortable: true,
      });

      if (!this.$store.getters.RIGHTS_ON_BRANCH_LEVEL)
        result.splice(result.length, 0, {
          text: this.$t('referenceBooks.devices.Status'),
          value: 'deviceStatus',
          sortable: true,
        });

      result.splice(
        result.length,
        0,
        {
          text: this.$t('referenceBooks.devices.embosserRibbon'),
          value: 'embosserRemainingPercent',
          sortable: false,
        },
        {
          text: this.$t('referenceBooks.devices.printerRibbon'),
          value: 'printerRemainingPercent',
          sortable: false,
        },
        {
          text: this.$t('referenceBooks.devices.indentRibbon'),
          value: 'indentRemainingPercent',
          sortable: false,
        }
      );

      return result;
    },
    hasManageKeyRights() {
      return this.$store.getters.CAN_MANAGE_KEY_TPK;
    },

    filteredKiosks() {
      return this.kiosks;
    },
    branchesOfBanks() {
      if (this.bankFilterArray.length === 0) return this.branches;

      return this.branches.filter((branch) => {
        return this.bankFilterArray.some(
          (bank) => bank.bankId === branch.bankId
        );
      });
    },
    filterJson() {
      const result = {};

      result.branchesId = this.branchFilterArray.map(
        (branch) => branch.branchId
      );
      result.banksId = this.bankFilterArray.map((bank) => bank.bankId);
      result.devicesId = this.devicesFilterArray.map((val) => val.deviceId);
      result.kioskStatusId = this.kioskStatusFilterArray.map(
        (val) => val.deviceStatusId
      );
      result.softwareStatusId = this.softwareStatusFilterArray.map(
        (val) => val.deviceStatusId
      );
      result.kioskName = this.kioskNameFilter;
      result.address = this.addressFilter;

      return result;
    },
    apiUri() {
      return this.$store.state.apiUri;
    },
    OrderBy() {
      const Sort = [];

      if (this.currentSort.length == 0) this.restoreSort();

      for (let i = 0; i < this.currentSort.length; i++) {
        Sort.splice(0, 0, {
          Name: NamesDB[this.currentSort[i]],
          SortUp: !this.currentSortDesc[i],
        });
      }

      return { Sort };
    },
  },
  async mounted() {
    this.intervalTime = this.$localStorageObj.getIntervalTime();
    this.setDefaultSort();

    await this.$axios.banks
      .get()
      .then((response) => response.data)
      .then((json) => {
        this.banks = json;
      })
      .catch((error) => {
        console.error(error);
      });

    if (this.$localStorageObj.getKeepFiltersValue(this.$store.getters.USERNAME)) {
      const savedBankFilter = this.$localStorageObj.getBankFilter(this.pageKey, this.$store.getters.USERNAME);
      const savedBranchFilter = this.$localStorageObj.getBranchFilter(this.pageKey, this.$store.getters.USERNAME);

      if (savedBankFilter && savedBankFilter.length > 0) {
        const savedBankIds = savedBankFilter.map((b) => b.bankId || b);
        this.bankFilterArray = this.banks.filter((bank) =>
          savedBankIds.includes(bank.bankId)
        );
      }

      if (savedBranchFilter && savedBranchFilter.length > 0 && this.bankFilterArray.length > 0) {
        this.$nextTick(() => {
          setTimeout(() => {
            const savedBranchIds = savedBranchFilter.map((b) => b.branchId || b);
            if (this.branches && this.branches.length > 0) {
              this.branchFilterArray = this.branches.filter((branch) =>
                savedBranchIds.includes(branch.branchId)
              );
            }
          }, 800);
        });
      }
    }

    await this.getKioskStatuses();
    await this.getSoftwareStatuses();
    await this.getKiosks();
    this.startTimer();

    this.isMounted = true;
  },

  beforeDestroy() {
    this.stopTimer();
  },

  methods: {
    getKioskStatuses() {
      this.$axios.statusTypes
        .get()
        .then((resp) => resp.data)
        .then((json) => {
          this.kioskStatuses = json;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getSoftwareStatuses() {
      this.$axios.statusTypes
        .get()
        .then((resp) => resp.data)
        .then((json) => (this.softwareStatuses = json))
        .catch((error) => {
          console.error(error);
        });
    },
    async onRestore() {
      const val = this.selected[0];
      await this.$axios.kiosks
        .restore(val.kioskId)
        .then((response) => {
          if (response.status == 200) {
            notifySuccess(
              '',
              this.$t('Messages.KioskWasRestored', [val.kioskName])
            );
          } else
            this.showMessage(
              this.$t('Restored'),
              `${this.$t('referenceBooks.kiosks.Name')}: ${
                val.kioskName
              }\n${this.$t('Status')}: ${response.status}`,
              'warn'
            );
          this.getKiosks();
        })
        .catch((error) => {
          console.error(error);
          this.catchError(
            error,
            val.deviceName,
            this.$t('errorsMessages.Restore')
          );
        });
    },
    async onDeleteKiosk(kiosk) {
      await this.$axios.kiosks
        .delete(kiosk.kioskId)
        .then(() => {
          notifySuccess(
            '',
            this.$t('Messages.KioskWasDeleted', [kiosk.kioskName])
          );
          this.getKiosks();
        })
        .catch((error) => {
          this.catchError(error, '', this.$t('errorsMessages.Delete'));
        });
    },
    clearFilters() {
      if (this.banks != null && this.banks.length == 1)
        this.bankFilterArray = this.banks[0];
      else this.bankFilterArray = [];

      if (this.branchesOfBanks != null && this.branchesOfBanks.length == 1)
        this.branchFilterArray = this.branchesOfBanks[0];
      else this.branchFilterArray = [];

      if (this.$localStorageObj.getKeepFiltersValue(this.$store.getters.USERNAME)) {
        this.$localStorageObj.setBankFilter(this.bankFilterArray, this.pageKey, this.$store.getters.USERNAME);
        this.$localStorageObj.setBranchFilter(this.branchFilterArray, this.pageKey, this.$store.getters.USERNAME);
      }
    },
    onResetKeyTPK() {
      const info = {};
      info.TempField = null;
      try {
        this.$axios.kiosks.changeKeyRTP(this.selected[0].kioskId, info);
        this.dialog = false;
        notifySuccess('', this.$t('Success'));
        this.$emit('ok');
      } catch (err) {
        console.error(err);
        notifyError('', this.$t('Error') + err);
      }
    },
    getKiosksAndStartTimer() {
      this.stopTimer();
      window.setTimeout(
        async function () {
          if (!this.waitingKiosksResponse) {
            this.waitingKiosksResponse = true;
            await this.getKiosks();
            this.waitingKiosksResponse = false;
          }
        }.bind(this),
        0
      );
      this.startTimer();
    },

    rerender() {
      this.manageKioskDialogKey++;
      this.getKiosksAndStartTimer();
    },
    stopTimer() {
      this.waitingKiosksResponse = false;
      if (this.interval) {
        window.clearInterval(this.interval);
      }
    },
    startTimer() {
      this.stopTimer();
      this.interval = window.setInterval(
        async function () {
          if (!this.waitingKiosksResponse) {
            this.waitingKiosksResponse = true;
            await this.getKiosks();
            this.waitingKiosksResponse = false;
          }
        }.bind(this),
        this.intervalTime * 1000
      );
    },
    clearBranches() {
      this.branchFilterArray = [];
    },

    kioskToServiceMode() {
      this.$axios.embRequests
        .toggleSuspended({ kioskId: this.selected[0].kioskId })
        .then(() => this.showMessage('GOOD', 'someText'))
        .catch((error) => {
          this.catchError(error, '', this.$t('ERROR'));
        });
    },

    restartApplication() {
      this.$axios.embRequests
        .restartApplication({ kioskId: this.selected[0].kioskId })
        .then(() => this.showMessage('GOOD', 'someText'))
        .catch((error) => {
          this.catchError(error, '', this.$t('ERROR'));
        });
    },

    restartPc() {
      this.$axios.embRequests
        .restartPc({ kioskId: this.selected[0].kioskId })
        .then(() => this.showMessage('GOOD', 'someText'))
        .catch((error) => {
          this.catchError(error, '', this.$t('ERROR'));
        });
    },

    async getKiosks() {
      if (this.loading) return;

      this.loading = true;
      const page = this.page;
      let flag = false;
      const orderBy = this.OrderBy;
      try {
        const params = {
          limit: this.limit,
          offset: this.limit * (this.page - 1),
          query: JSON.stringify(this.filterJson),
        };

        if (orderBy.Sort != undefined && orderBy.Sort != null)
          params.orderby = JSON.stringify(orderBy);

        await this.$axios.kiosks
          .get(params)
          .then((response) => response.data)
          .then((json) => {
            if (this.page == page) {
              this.kiosks = json.kiosks;
              this.paginationLength = Math.ceil(json.totalCount / this.limit);
              this.totalCount = json.totalCount;
            } else flag = true;
          });
      } catch (error) {
        console.error(error);
      }
      this.loading = false;
      if (flag) this.getKiosks()();
    },
    async refreshKiosks() {
      this.eager = !this.eager;
      await this.getKiosks();
    },
    onDateChange(dateFrom, dateTo) {
      this.jobDateFilter = [];
      this.jobDateFilter.push(dateFrom);
      this.jobDateFilter.push(dateTo);
    },
    //-------------------------SORT--------------------
    setDefaultSort() {
      this.currentSort.splice(0, 0, 'bankName');
      this.currentSortDesc.splice(0, 0, false);
    },
    restoreSort() {
      this.currentSort.splice(0, 0, this.lastSort);
      this.currentSortDesc.splice(0, 0, false);
    },
    customSort: function (items) {
      return items;
    },
    clearFiltersOnSave() {},
    onSaved(status, kiosk) {
      this.clearFiltersOnSave();
      this.getKiosks();

      if (status == 200)
        this.showMessage(
          this.$t('kiosks.saved'),
          `${this.$t('kiosks.name')}: ${kiosk.kioskName}`
        );
      else
        this.showMessage(
          this.$t('kiosks.saved'),
          `${this.$t('kiosks.name')}: ${kiosk.kioskName}`,
          'warn'
        );
    },
    onCreated(status, deviceName, id) {
      this.getKiosks();
      if (status == 200)
        this.showMessage(
          this.$t('referenceBooks.devices.created'),
          `${this.$t('referenceBooks.devices.Name')}: ${deviceName}`
        );
      else
        this.showMessage(
          this.$t('referenceBooks.devices.created'),
          `${this.$t('referenceBooks.devices.Name')}: ${deviceName}`,
          'warn'
        );

      this.markRow(id);
    },
    markRow(id) {
      this.changedDevicesId = [];
      this.changedDevicesId.push(id);
    },

    async downloadLogs(dates) {
      const params = {
        kioskId: this.selected[0].kioskId,
        from: dates.dateFrom.split('-').join(''),
        to: dates.dateTo.split('-').join(''),
      };

      try {
        const checkResponse = await this.$axios.kiosks.checkLogs(params);
        const logType = String(checkResponse.data || '').toLowerCase().trim();
        const ext = logType === 'zip' ? 'zip' : 'log';
        const response = await this.$axios.kiosks.downloadLogsFile(params);
        const blob = response.data;
        const blobUrl = URL.createObjectURL(blob);
        const disposition = response.headers['content-disposition'];
        const filenameMatch = disposition && /filename\*?=(?:UTF-8'')?"?([^";\n]+)"?/i.exec(disposition);
        const filename = filenameMatch ? filenameMatch[1].trim() : `logs.${ext}`;
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      } catch (error) {
        const response = error.response;
        if (response && response.status === 404) this.onError(this.$t('kiosks.logsNotFound'));
        else this.onError(error);
      }
    },
    async downloadMedia(files) {
      const params = {
        kioskId: this.selected[0].kioskId,
      };

      try {
        await this.$axios.kiosks
          .prepareMedia(params, files)
          .then((response) => response.data)
          .then((fname) => {
            const params2 = {
              kioskId: this.selected[0].kioskId,
              zipName: fname,
            };
            var url = this.$axios.kiosks.getDownloadMediaUrl(params2);

            const link = document.createElement('a');
            link.href = url;
            link.style.display = 'none';
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            const response = error.response;
            if (
              response &&
              response.status === 404 &&
              response.statusText === 'Not Found'
            )
              this.onError(this.$t('kiosks.logsNotFound'));
            else this.onError(error);
          });
      } catch (err) {
        this.onError(err);
      }
    },
    getDateNow() {
      const date = new Date();
      var year = date.getFullYear();
      var month = this.padStart(date.getMonth());
      var day = this.padStart(date.getDate());
      var hours = this.padStart(date.getHours());
      var minutes = this.padStart(date.getMinutes());
      var seconds = this.padStart(date.getSeconds());

      return `${year}.${month}.${day}_${hours}-${minutes}-${seconds}`;
    },
    padStart(val, count = 2, char = '0') {
      return val.toString().padStart(count, char);
    },
    async onError(error, errorHeader = '') {
      console.error(error);
      this.catchError(error, '', errorHeader);
    },
    catchError(error, text, title) {
      this.showMessage(title, text + error, 'error');
    },
    showMessage(title, text, type = '') {
      Vue.notify({
        group: 'notif',
        title: title,
        text: text,
        type: type,
      });
    },
  },
  components: {
    CardsPerHopperForm,
    ComboboxFilter2000,
    EditKeyTPK,
    Confirm,
    SearchButtons,
    KisosksAddEditDialog,
    KisosksChangeDevice,
    Confirm1,
    DownloadForm,
    MediaDownloadForm,
  },
};
</script>
